import { Component, Input } from '@angular/core';
import { NavController, Events, ModalController } from 'ionic-angular';

@Component({
  selector: 'custom-header',
  template: `
    <ion-navbar color="header">
      <ion-title>{{headerData.title}}</ion-title>

      <ion-buttons start>
        <button ion-button (click)="toggleMenu()" hideWhen="landscape">
          <ion-icon name="menu"></ion-icon>
        </button>
      </ion-buttons>
    </ion-navbar>
  `
})
export class CustomHeaderComponent {
  headerData: any;

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public modalCtrl: ModalController
  ) {}

  @Input()
  set header( headerData: any ) 
  {
    this.headerData = headerData;
  }
  get header() {
    return this.headerData;
  }

  toggleMenu()
  {
    this.events.publish('menu:toggle');
  }
}


// WEBPACK FOOTER //
// ./src/components/header-custom.component.ts